import Vue from 'vue';

Vue.directive('persian-to-english', {
    bind(el, binding, vnode) {
    let isChanging = false;
    const inputMode = el.getAttribute('inputmode');
    let handler = function(e) {
        if (inputMode === 'numeric' && !isChanging && e.target.value.length > 0) {
            isChanging = true
            e.target.value = persianToEnglish(el.value);
            vnode.elm.dispatchEvent(new CustomEvent('input'))
            isChanging = false;
        }
    }
    el.addEventListener('input', handler);
    }
});

function persianToEnglish(value) {
 const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
 const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
 if (typeof value === 'string') {
  for (let i = 0; i < 10; i++) {
   value = value.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
  }
 }
 return value;
}